import { useCurrentUser } from 'hooks/auth';

import { Job } from '@libs/graphql-types';

export const useIsV2JobVew = ({ job }: { job?: Job }) => {
  const { data } = useCurrentUser();
  const jobSource = job?.job_source_type === 'STRIIVE';

  return data?.currentCompanyUser?.company?.region === 'US' && jobSource;
};
